import { createFileRoute } from "@tanstack/react-router"
import ActivityListPage from "@/app/activity/list/page"
import type { ActivityViewMode } from "@/app/activity/store/activityCommonStore"

export type ActivityListSearch = {
  view?: ActivityViewMode
  date?: string
  types?: string
  matchDay?: string
  seasonWeek?: string
  player?: string
  q?: string
  startMon?: 1
  alignMd?: 1
}

const VIEW_MODES: ActivityViewMode[] = ["month", "week", "schedule"]

export const Route = createFileRoute("/activity/list")({
  component: ActivityListPage,
  validateSearch: (search: Record<string, unknown>): ActivityListSearch => {
    const view = typeof search.view === "string" ? search.view : undefined

    return {
      view:
        view && VIEW_MODES.includes(view as ActivityViewMode)
          ? (view as ActivityViewMode)
          : undefined,
      date: typeof search.date === "string" ? search.date : undefined,
      types: typeof search.types === "string" ? search.types : undefined,
      matchDay: typeof search.matchDay === "string" ? search.matchDay : undefined,
      seasonWeek: typeof search.seasonWeek === "string" ? search.seasonWeek : undefined,
      player: typeof search.player === "string" ? search.player : undefined,
      q: typeof search.q === "string" ? search.q : undefined,
      startMon: search.startMon === 1 || search.startMon === "1" ? 1 : undefined,
      alignMd: search.alignMd === 1 || search.alignMd === "1" ? 1 : undefined,
    }
  },
})
